export default __webpack_public_path__ + "media/images/partners/partner-logo-nvidia.png";